'use strict';

angular.module('licensure.services')
    .factory('SecurityTemplatePermissions', ['$http', '$q', function ($http, $q) {
        return {
            get: function (userPermissions) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/securitytemplatepermissions', {
                        params: {
                            userPermissions: userPermissions
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;